import React, { useState } from 'react';
import { resolvePublicMediaUrl } from '../utils/mediaUrl';

const PLACEHOLDER_SVG =
  'data:image/svg+xml,' +
  encodeURIComponent(
    '<svg xmlns="http://www.w3.org/2000/svg" width="400" height="240" viewBox="0 0 400 240"><rect fill="#e2e8f0" width="400" height="240"/><text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" fill="#94a3b8" font-family="system-ui,sans-serif" font-size="14">Image unavailable</text></svg>'
  );

export default function SafeImg({ src, alt = '', className, style, loading, ...rest }) {
  const [failed, setFailed] = useState(false);
  const resolved = resolvePublicMediaUrl(src);
  const display = failed || !resolved ? PLACEHOLDER_SVG : resolved;

  return (
    <img
      src={display}
      alt={alt}
      className={className}
      style={style}
      loading={loading}
      onError={() => setFailed(true)}
      {...rest}
    />
  );
}
